import React from "react";
import "./blogs.css";
import blogOne from "../../Media/blogone.jpg";
import blogTwo from "../../Media/blogtwo.jpg";
import blogThree from "../../Media/blogthree.jpg";
import smallArrow from "../../Media/smallarrow.svg";
import { GoArrowRight } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const Blogs = () => {
  const navigate = useNavigate();
  return (
    <section className="blog-section">
      <div className="blog-heading">
        <h2 className="blogs-text">Blogs</h2>
      </div>
      <div className="blog-post">
        <div className="blog-one">
          <div className="blog-image-container-one">
            <img className="blog-img-first" src={blogOne} alt="blog post one" onClick={() => navigate("/blog")}/>
          </div>
          <div className="blog-content-text-one">
            <h3 className="blog-sub-heading-one">Blog Series</h3>
            <p className="blog-content-one">
              World Day Against Cyber Censorship
            </p>
          </div>
          <div className="button-section">
            <button className="small-arrow" onClick={() => navigate("/blog")}>
              <span className="testing">Know more</span>
              <img className=" blogs-bluearrow" src={smallArrow} alt="" />
            </button>
          </div>
        </div>
        <div className="blog-two">
          <div className="blog-image-container-one">
            <img className="blog-img-first" src={blogTwo} alt="blog post two" onClick={() => navigate("/blog")}/>
          </div>
          <div className="blog-content-text-one">
            <h3 className="blog-sub-heading-one">Blog Series</h3>
            <p className="blog-content-one">
              Top 5 Startup Challenges and their Solutions in 2025
            </p>
          </div>
          <div className="button-section">
            <button className="small-arrow" onClick={() => navigate("/blog")}>
              <span className="testing">Know more</span>
              <img className=" blogs-bluearrow" src={smallArrow} alt="" />
            </button>
          </div>
        </div>
        <div className="blog-three">
          <div className="blog-image-container-one">
            <img
              className="blog-img-first"
              src={blogThree}
              alt="blog post three"
              onClick={() => navigate("/blog")}
            />
          </div>
          <div className="blog-content-text-one">
            <h3 className="blog-sub-heading-one">Blog Series</h3>
            <p className="blog-content-one">The Evolution of Web Development</p>
          </div>
          <div className="button-section">
            <button className="small-arrow" onClick={() => navigate("/blog")}>
              <span className="testing">Know more</span>
              <img className=" blogs-bluearrow" src={smallArrow} alt="" />
            </button>
          </div>
        </div>
      </div>
      <div className="blog-button">
        <button className="blog-small-button" onClick={() => navigate("/blog")}>
          <span className="testing">Explore more</span>
          <GoArrowRight className="blogs-blackarrow" />
        </button>
      </div>
    </section>
  );
};

export default Blogs;
